import { render, staticRenderFns } from "./area.vue.html?vue&type=template&id=218a90b2"
import script from "./area.controller.ts?vue&type=script&lang=js&external"
export * from "./area.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports